// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39763f23","455":"065a4346","977":"048e7e8f"}[chunkId] + ".chunk.js";
};